import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n'; // Initialize i18n before App
import './index.css';
import App from './App.tsx';

// =============================================================================
// Theme Initialization
// =============================================================================
// Apply BCT product theme before React render to prevent flash of unstyled content (FOUC).
// Dark mode is handled by @bct/styleguide ThemeProvider; DarkModeSync restores the
// user's preference after mount. We also pre-apply the `dark` class here based on
// localStorage so a refresh in dark mode doesn't flash to light first.
// Set default BCT theme to 'governance' - organization theme loads after auth via ThemeProvider.
document.documentElement.setAttribute('data-theme', 'governance');

try {
  if (localStorage.getItem('pregoo-dark-mode') === 'true') {
    document.documentElement.classList.add('dark');
  }
} catch {
  // localStorage may be unavailable (private mode, etc.) — ignore.
}

// Clear the chunk reload flag on successful page load
sessionStorage.removeItem('lazy-chunk-reload');

// =============================================================================
// React Application Mount
// =============================================================================
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        </div>
      }
    >
      <App />
    </Suspense>
  </StrictMode>,
);
